import { genericPage, getServerSidePropsHelper } from 'components/corporatiu/Page';
import { useRouter } from 'next/router';

const path = ['web', process.env.FOLDER_LAYOUTS_CORPORATIU, 'tv3', 'marato', 'recerca', 'seccio'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, path);
};

export async function getServerSideProps(context) {
    context.query.lang = 'en';
    context.query.seccio = 'recerca';
    context.query.slug = 'recerca';
    return getServerSidePropsHelper(context, { slugs: path, id: 65 });
}

export default Pagina;
